angular.module('visitIstriaApp').filter('capitalize', function () {
    return function(value) {
        if (typeof value === 'string') return value[0].toUpperCase() + value.substring(1);
    }
});